import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_BILL_TERM,
   DELETE_BILL_TERM,
   GET_BILL_TERM,
   UPDATE_BILL_TERM,
   GET_ONE_BILL_TERM,
   MULTI_DELETE_BILLTERM,
} from '../types';

export const getBillTerm = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/bill-term/all', { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_BILL_TERM,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Color. Please try again.", err);
   }
};

export const addBillTerm = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/bill-term/add', formData);
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 1) {
         dispatch({ type: ADD_BILL_TERM, payload: res.data.data });
         setTimeout(() => {
            toast.success('Bill-Term added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const updateBillTerm = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/bill-term/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_BILL_TERM, payload: res.data.data });

         setTimeout(() => {
            toast.success('Bill-Term updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Delete Bill Term
export const deleteBillTerm = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/bill-term/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_BILL_TERM, payload: { id } });
         setTimeout(() => {
            toast.success('Bill-Term deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const multiDeleteBillTerm = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/bill-term/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_BILLTERM, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleBillTerm = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/bill-term/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_BILL_TERM, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
